import {useEffect, useState} from "react";

function TimedErrorMessage({ message, done }) {
    const [opacity, setOpacity] = useState(1);

    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setOpacity(0);
                setTimeout(() => {
                    setOpacity(1);
                    done();
                }, 500);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [message, done]);

    return (
        message && (
            <span className="text-danger small"
                style={{
                    padding: '10px',
                    marginBottom: '10px',
                    opacity,
                    transition: 'opacity 0.5s ease-in-out',
                }}
            >
                {message}
            </span>
        )
    )

}

export default TimedErrorMessage;